import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions({
      notify: 'notification/notify'
    }),
    async $notification (toNotify) {
      if (process.env.NODE_ENV === 'development' && toNotify instanceof Error) {
        console.error(toNotify)
      }
      if (toNotify instanceof Promise) {
        try {
          const response = await toNotify
          this.notify(response)
          return Promise.resolve(response)
        } catch (e) {
          if (e.hasOwnProperty('message') || e.errors.hasOwnProperty('message')) {
            this.notify(e.message || e)
            return Promise.reject(new Error('Something bad happened'))
          } else {
            return Promise.reject(e.errors)
          }
        }
      } else {
        this.notify(toNotify)
      }
    }

  }
}
